import { isTypeTableOfContentsSetting } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulTableOfContentsSetting = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeTableOfContentsSetting(entry)) {
    return null;
  }

  // Intentionally left blank as we manage table of contents in ContentfulPage.tsx
  return <div />;
};

export default ContentfulTableOfContentsSetting;
